import Modal from 'react-modal';
import { TextField } from '@mui/material';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from "react-hot-toast";
import { sendQuestionnaire } from '../../../../services/api.service';
import CustomButtonSimple from '../../../../components/CustomMiscellaneous/CustomButtonSimple';
import { palette } from '../../../../assets/theme/theme';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        display: 'flex',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        justifyContent: 'center'
    },
};

export function EmailQuestionarioSatisfacao({ isOpen, close, obraId, refetch }: { isOpen: boolean, close: () => void, obraId?: number, refetch: ()=> void }) {

    const [clientEmail, setClientEmail] = useState<string>('');

    const sendEmailMutation = useMutation(({email, id} : {email: string, id: number})=> sendQuestionnaire(id,email), {
        onSuccess: ()=> {
            toast.success("Email enviado com sucesso!");
            refetch();
            close();
        },
        onError: ()=> {
            toast.error("Erro ao enviar email!")
        }
    })

    return (
        <Modal style={customStyles} isOpen={isOpen}>
            <div className='p-4'>

                <TextField
                    label={`Email cliente`}
                    variant={'outlined'}
                    className='w-full'
                    onChange={(e) => setClientEmail(e.target.value)}
                    value={clientEmail}
                    type={'text'}
                    lang="en-US"
                />

                <div style={{ display: 'flex', justifyContent: 'space-between ', marginTop: 25 }}>
                    <CustomButtonSimple color={palette.red} text={"Cancelar"} onClick={close}></CustomButtonSimple>
                    <CustomButtonSimple color={palette.green} text={"Confirmar"} onClick={() => sendEmailMutation.mutate({ email: clientEmail, id: obraId || 0})}></CustomButtonSimple>
                </div>
            </div>
        </Modal>
    )

}